import {connect} from 'react-redux';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {getCustomFieldsForAccounts} from '../../../store/data/customFields/customFieldsSelectors';
import {getIsUserGlobalAdmin} from '../../../store/data/teammates/teammatesSelectors';
import {
  ContactDetailsOrContactsManagerPanelId,
  createAccountFormUpdateCustomAttributeAction,
} from '../../../store/panels/accounts/createAccountForm/createAccountFormActions';
import {navigateToLinkAction} from '../../../store/stateless/navigationActions';
import {CreateAccountFormCustomAttributes} from './createAccountFormCustomAttributes';

/*
 * Props.
 */

interface CreateAccountFormCustomAttributesContainerProps {
  panelId: ContactDetailsOrContactsManagerPanelId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  customFieldsMap: getCustomFieldsForAccounts,
  isUserGlobalAdmin: getIsUserGlobalAdmin,
}));

const mapDispatchToProps = makeMapDispatchToProps<CreateAccountFormCustomAttributesContainerProps>()(
  (props) => ({
    onUpdateCustomAttribute: (customFieldId: number, value: string) =>
      createAccountFormUpdateCustomAttributeAction(props.panelId, customFieldId, value),
    onNavigateToCustomFieldsSettings: () =>
      navigateToLinkAction('/settings/global/custom-fields/accounts/overview'),
  }),
);

export const CreateAccountFormCustomAttributesContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateAccountFormCustomAttributes);
